import { NotificationsAction } from './notifications.actions';
import { Notification } from '../../models/communication/Notification.model';
import { InitializerAction } from '../initializer/initiliazer.action';

export class NotificationsState {
    notifications: Array<Notification>;
    pending: boolean;
    error: null;
    realtimeNotification: any;
}

export const initialState: NotificationsState = {
    notifications: [],
    pending: false,
    error: null,
    realtimeNotification: null
}

export function NotificationsReducer(state: NotificationsState = initialState, action: NotificationsAction){

    switch (action.type) {

        case NotificationsAction.getNotifications:
            return {...{}, ...state, ...{ pending: true, error: null }};
        case NotificationsAction.getNotificationsSuccess:
            return {...{}, ...state, ...{ notifications: action.payload, pending: false, error: null }};
        case NotificationsAction.getNotificationsError:
            return {...{}, ...state, ...{ pending: false, error: action.payload }};

        case NotificationsAction.subscribeNotificationChannel:
            return {...{}, ...state, ...{ pending: true, error: null }};
        case NotificationsAction.subscribeNotificationChannelSuccess:
            return {...{}, ...state, ...{ notifications: [action.payload, ...state.notifications], realtimeNotification: action.payload, pending: false, error: null }};
        case NotificationsAction.subscribeNotificationChannelError:
            return {...{}, ...state, ...{ pending: false, error: action.payload }};

        case NotificationsAction.readNotification:
            return {...{}, ...state, ...{ pending: true, error: null }};
        case NotificationsAction.readNotificationSuccess:
            const arr = [...[], ...state.notifications];
            arr.map(item => { 
                if (item.messageID == action.payload.messageID) {
                    item.readStatus = 1;
                }
                return item;
            });
            return {...{}, ...state, ...{ notifications: arr, pending: false, error: null }};
        case NotificationsAction.readNotificationError:
            return {...{}, ...state, ...{ pending: false, error: action.payload }};

        case InitializerAction.resetUserRelatedData:
            return {...state, ...{notifications: initialState.notifications, realtimeNotification: initialState.realtimeNotification }};
            
        default:
            return state;
    }
};
